// extracted by mini-css-extract-plugin
module.exports = {"image-container":"Image_image-container__hvODi","image":"Image_image__1H4C3"};